import { render } from "./FormCustomer.vue?vue&type=template&id=0c5a3063"
import script from "./FormCustomer.vue?vue&type=script&lang=js"
export * from "./FormCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__